module.exports = "/images/sr.svg";